import React from 'react';
import PropTypes from 'prop-types';
import * as S from './Answers.styles';
import { Audio } from 'modules/Core/Common/Audio';

const ParagraphComponent = ({
  paragraphs = [],
  passage_image,
  passage_audio,
}) => (
  <S.CommonContainer>
    {paragraphs.map((paragraph) => (
      <S.ParagraphContainer key={paragraph?.id}>
        <S.CommonText>{paragraph?.paragraph_text}</S.CommonText>
      </S.ParagraphContainer>
    ))}
    {passage_image?.web_normal?.url && (
      <S.CommonImage src={passage_image.web_normal.url} />
    )}
    {passage_audio?.url && <Audio url={passage_audio?.url} />}
  </S.CommonContainer>
);

ParagraphComponent.propTypes = {
  paragraphs: PropTypes.array.isRequired,
  passage_image: PropTypes.object,
  passage_audio: PropTypes.object,
};

export { ParagraphComponent };
